// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"cc8cdd32","455":"0110e430","977":"41c9292e"}[chunkId] + ".chunk.js";
};